export const nreSearchParams = `
    [
        {
            "active": true,
            "canSave": false,
            "clearOnBack": false,
            "property": {
                "name": "surname",
                "value": "",
                "type": "string"
            },
            "labelTranslationKey": "LastName",
            "layout": {
                "row": 0,
                "column": 0,
                "autofocus": true,
                "stretch": true
            }
        },
        {
            "active": true,
            "canSave": false,
            "property": {
                "name": "name",
                "value": "",
                "type": "string"
            },
            "labelTranslationKey": "FirstName",
            "layout": {
                "row": 1,
                "column": 0,
                "stretch": true
            }
        },
        {
            "active": true,
            "canSave": true,
            "clearOnBack": false,
            "property": {
                "name": "date",
                "value": {
                    "from": "0#-2#0",
                    "to": "0#0#0"
                },
                "defaultValue": {
                    "from": "0#-2#0",
                    "to": "0#0#0"
                },
                "type": "fromTo"
            },
            "labelTranslationKey": {
                "from": "From",
                "to": "To",
                "label": "EnrolmentStartDate"
            },
            "layout": {
                "row": 2,
                "column": 0,
                "stretch": true
            }
        },
        {
            "active": true,
            "canSave": true,
            "clearOnBack": false,
            "property": {
                "name": "IdBusinessUnit",
                "value": null,
                "type": "filterSelect",
                "itemsSourceInfo": {
                    "form": "nre",
                    "controllerName": "RadiologyCommon",
                    "methodName": "GetBusinessUnits",
                    "displayProperty": "description",
                    "enableTooltip": true,
                    "sortCollectionDataInfo": {
                        "field": "description"
                    }
                }
            },
            "labelTranslationKey": "BusinessUnit",
            "layout": {
                "row": 3,
                "column": 0,
                "stretch": true
            }
        }
    ]`;
